import * as Cesium from 'cesium';
import BaseLayer from "./baseLayer";
import CONSTANTS from "../constants";
/**
 *重大危险源图层
 */
export default class DangerLayer extends BaseLayer{

    constructor(options= {}){
        options.layerName=options.layerName||CONSTANTS.LAYER.DANGER;//图层名
        super(options);
    }

    addEntities(data){
        let self=this;
        self.clearLayer();
        data.forEach((obj) =>{
            let item={...obj};
            item.layerName=self.layerName;
            if(item.majorHazardsLevel==1){
                item.majorHazardsLevelName="一级";
            }
            if(item.majorHazardsLevel==2){
                item.majorHazardsLevelName="二级";
            }
            if(item.majorHazardsLevel==3){
                item.majorHazardsLevelName="三级";
            }
            if(item.majorHazardsLevel==4){
                item.majorHazardsLevelName="四级";
            }
            if(item.longitude&&item.latitude){
                let entity=new Cesium.Entity({
                    position: Cesium.Cartesian3.fromDegrees(item.longitude,item.latitude, CONSTANTS.ALTITUDE),
                    id:item.id,
                    attributes:item,
                    //立广告牌
                    billboard :{
                        image : require("../../img/map/anger"+item.type+".png"),
                        show : true,
                        width : 57,
                        height : 65,
                        pixelOffset:new Cesium.Cartesian2(0, 0),
                        heightReference:Cesium.HeightReference.CLAMP_TO_GROUND
                    }
                });
                self.dataSource.entities.add(entity);
            }
        });

    }
};
